export default "__VITE_PUBLIC_ASSET__514e2846__"